
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "../assets/AdminMessage.css";

// const AdminMessageWithSmsForm = () => {
//   const [apiKey, setApiKey] = useState("4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8"); 
//   const [templateList, setTemplateList] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState("");
//   const [selectedTemplateObj, setSelectedTemplateObj] = useState(null);
//   const [variables, setVariables] = useState([]);
//   const [numbers, setNumbers] = useState("");
//   const [response, setResponse] = useState(null);
//   const [loadingTemplates, setLoadingTemplates] = useState(false);

//   useEffect(() => {
//     const fetchTemplates = async () => {
//       setLoadingTemplates(true);
//       try {
//         const res = await axios.get(
//           `https://www.fast2sms.com/dev/dlt_manager?authorization=4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8&type=template`
//         );

//         if (res.data.success && res.data.data.length > 0) {
//           const filteredTemplates = res.data.data.filter(
//             (item) => item.sender_id === "SGDMSA"
//           );
//           setTemplateList(filteredTemplates);
//         } else {
//           setTemplateList([]);
//           alert("No templates found for sender_id SGDMSA");
//         }
//       } catch (error) {
//         console.error("Error fetching templates:", error);
//         alert("Error fetching templates");
//       } finally {
//         setLoadingTemplates(false);
//       }
//     };

//     fetchTemplates();
//   }, [apiKey]);

//   const handleTemplateSelect = (e) => {
//     const templateId = e.target.value;
//     setSelectedTemplate(templateId);

//     const templateObj = templateList
//       .flatMap((item) => item.templates)
//       .find((tpl) => tpl.message_id.toString() === templateId);

//     setSelectedTemplateObj(templateObj || null);

//     const varCount = templateObj ? templateObj.var_count : 0;
//     setVariables(Array(varCount).fill(""));
//   };

//   const handleVariableChange = (index, value) => {
//     const updatedVars = [...variables];
//     updatedVars[index] = value;
//     setVariables(updatedVars);
//   };
// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!selectedTemplateObj || !numbers) {
//     alert("Template and Numbers are required");
//     return;
//   }

//   const variables_values = variables.join("|");
//   const API_BASE = "https://narrowitsolution.in/api";

//   const data = {
//     route: "dlt",
//     sender_id: "SGDMSA",  // Your correct DLT_SENDER_ID
//     message: selectedTemplateObj.message_id,
//     variables_values: variables_values,
//     numbers: numbers,
//   };

//   try {
//     const res = await axios.post(
//       `${API_BASE}/send-sms-fast2sms`,
//       { data }, // <-- wrap inside { data: ... }
//       {
//         headers: {
//           authorization: "4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8",
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     setResponse(res.data);
//   } catch (error) {
//     console.error("Error sending SMS:", error);
//     setResponse({ error: error.message });
//   }
// };



//   return (
//     <div className="sms-form">
//       <h2>Send DLT SMS</h2>
// {/* 
//       {loadingTemplates ? (
//         <p>Loading Templates...</p>
//       ) : (
//         <select value={selectedTemplate} onChange={handleTemplateSelect} required>
//           <option value="">Select Template</option>
//           {templateList.flatMap((item) =>
//             item.templates.map((tpl) => (
//               <option key={tpl.message_id} value={tpl.message_id}>
//                 {tpl.message_id} - {tpl.message}
//               </option>
//             ))
//           )}
//         </select>
//       )}

//       {selectedTemplateObj && (
//         <h2 style={{ margin: "15px 0", background: "#eef", padding: "10px", borderRadius: "5px" }}>
//           Template Preview: {selectedTemplateObj.message} <br />
//           Variables Count: {selectedTemplateObj.var_count}
//         </h2>
//       )}

//       {variables.map((val, idx) => (
//         <input
//           key={idx}
//           type="text"
//           placeholder={`Variable ${idx + 1}`}
//           value={val}
//           onChange={(e) => handleVariableChange(idx, e.target.value)}
//         />
//       ))}

//       <input
//         type="text"
//         placeholder="Mobile Numbers (comma separated)"
//         value={numbers}
//         onChange={(e) => setNumbers(e.target.value)}
//         required
//       />

//       <button type="submit" onClick={handleSubmit}>
//         Send SMS
//       </button>

//       {response && (
//         <pre style={{ marginTop: "20px", background: "#f5f5f5", padding: "10px", borderRadius: "5px" }}>
//           {JSON.stringify(response, null, 2)}
//         </pre>
//       )} */}
//     </div>
//   );
// };

// export default AdminMessageWithSmsForm;












// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "../assets/AdminMessage.css";

// const AdminMessageWithSmsForm = () => {
//   const [apiKey, setApiKey] = useState(""); 
//   const [templateList, setTemplateList] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState("");
//   const [selectedTemplateObj, setSelectedTemplateObj] = useState(null);
//   const [variables, setVariables] = useState([]); // Dynamic array of variables
//   const [numbers, setNumbers] = useState("");
//   const [response, setResponse] = useState(null);
//   const [loadingTemplates, setLoadingTemplates] = useState(false);

//   useEffect(() => {
//     const fetchTemplates = async () => {
//       setLoadingTemplates(true);
//       try {
//         const res = await axios.get(
//           `https://www.fast2sms.com/dev/dlt_manager?authorization=4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8&type=template`
//         );

//         if (res.data.success && res.data.data.length > 0) {
//           const filteredTemplates = res.data.data.filter(
//             (item) => item.sender_id === "SGDMSA"
//           );
//           setTemplateList(filteredTemplates);
//         } else {
//           setTemplateList([]);
//           alert("No templates found for sender_id SGDMSA");
//         }
//       } catch (error) {
//         console.error("Error fetching templates:", error);
//         alert("Error fetching templates");
//       } finally {
//         setLoadingTemplates(false);
//       }
//     };

//     fetchTemplates();
//   }, [apiKey]);

//   const handleTemplateSelect = (e) => {
//     const templateId = e.target.value;
//     setSelectedTemplate(templateId);

//     const templateObj = templateList
//       .flatMap((item) => item.templates)
//       .find((tpl) => tpl.message_id.toString() === templateId);

//     setSelectedTemplateObj(templateObj || null);

//     // Initialize variables array based on var_count
//     const varCount = templateObj ? templateObj.var_count : 0;
//     setVariables(Array(varCount).fill(""));  // Start with empty strings
//   };

//   const handleVariableChange = (index, value) => {
//     const updatedVars = [...variables];
//     updatedVars[index] = value;
//     setVariables(updatedVars);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedTemplateObj || !numbers) {
//       alert("Template and Numbers are required");
//       return;
//     }

//     const variables_values = variables.join("|");

//     const data = {
//       route: "dlt_manual",
//       requests: [
//         {
//           sender_id: "SGDMSA",
//           entity_id: templateList[0]?.entity_id || "",
//           template_id: selectedTemplateObj.message_id,
//           message: "DLT_APPROVED_MESSAGE",
//           flash: 0,
//           numbers,
//           variables_values,
//         },
//       ],
//     };

//     try {
//       const res = await axios.post(
//         "https://www.fast2sms.com/dev/custom",
//         data,
//         {
//           headers: {
//             authorization: apiKey,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setResponse(res.data);
//     } catch (error) {
//       console.error("Error sending SMS:", error);
//       setResponse({ error: error.message });
//     }
//   };

//   return (
//     <div className="sms-form">
//       <h2>Send DLT SMS</h2>

//       {loadingTemplates ? (
//         <p>Loading Templates...</p>
//       ) : (
//         <select value={selectedTemplate} onChange={handleTemplateSelect} required>
//           <option value="">Select Template</option>
//           {templateList.flatMap((item) =>
//             item.templates.map((tpl) => (
//               <option key={tpl.message_id} value={tpl.message_id}>
//                 {tpl.message_id} - {tpl.message}
//               </option>
//             ))
//           )}
//         </select>
//       )}

//       {selectedTemplateObj && (
//         <h2 style={{ margin: "15px 0", background: "#eef", padding: "10px", borderRadius: "5px" }}>
//           Template Preview: {selectedTemplateObj.message} <br />
//           Variables Count: {selectedTemplateObj.var_count}
//         </h2>
//       )}

//       {variables.map((val, idx) => (
//         <input
//           key={idx}
//           type="text"
//           placeholder={`Variable ${idx + 1}`}
//           value={val}
//           onChange={(e) => handleVariableChange(idx, e.target.value)}
//         />
//       ))}

//       <input
//         type="text"
//         placeholder="Mobile Numbers (comma separated)"
//         value={numbers}
//         onChange={(e) => setNumbers(e.target.value)}
//         required
//       />

//       <button type="submit" onClick={handleSubmit}>
//         Send SMS
//       </button>

//       {response && (
//         <pre style={{ marginTop: "20px", background: "#f5f5f5", padding: "10px", borderRadius: "5px" }}>
//           {JSON.stringify(response, null, 2)}
//         </pre>
//       )}
//     </div>
//   );
// };

// export default AdminMessageWithSmsForm;








import React, { useState, useEffect } from "react";
import axios from "axios";
import "../assets/AdminMessage.css";

const AdminMessageWithSmsForm = () => {
  const [apiKey, setApiKey] = useState("4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8"); 
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedTemplateObj, setSelectedTemplateObj] = useState(null);
  const [variables, setVariables] = useState([]);
  const [numbers, setNumbers] = useState("");
  const [response, setResponse] = useState(null);
  const [loadingTemplates, setLoadingTemplates] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoadingTemplates(true);
      try {
        const res = await axios.get(
          `https://www.fast2sms.com/dev/dlt_manager?authorization=4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8&type=template`
        );

        if (res.data.success && res.data.data.length > 0) {
          const filteredTemplates = res.data.data.filter(
            (item) => item.sender_id === "SGDMSA"
          );
          setTemplateList(filteredTemplates);
        } else {
          setTemplateList([]);
          alert("No templates found for sender_id SGDMSA");
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
        alert("Error fetching templates");
      } finally {
        setLoadingTemplates(false);
      }
    };

    fetchTemplates();
  }, [apiKey]);

  const handleTemplateSelect = (e) => {
    const templateId = e.target.value;
    setSelectedTemplate(templateId);

    const templateObj = templateList
      .flatMap((item) => item.templates)
      .find((tpl) => tpl.message_id.toString() === templateId);

    setSelectedTemplateObj(templateObj || null);

    const varCount = templateObj ? templateObj.var_count : 0;
    setVariables(Array(varCount).fill(""));
  };

  const handleVariableChange = (index, value) => {
    const updatedVars = [...variables];
    updatedVars[index] = value;
    setVariables(updatedVars);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!selectedTemplateObj || !numbers) {
  //     alert("Template and Numbers are required");
  //     return;
  //   }

  //   const variables_values = variables.join("|");
  //   const API_BASE = "https://narrowitsolution.in/api";

  //   const data = {
  //     route: "dlt",
  //     sender_id: "SGDMSA",  // Your correct DLT_SENDER_ID
  //     message: selectedTemplateObj.message_id,
  //     variables_values: variables_values,
  //     numbers: numbers,
  //   };
      

  //   try {
  //     const res = await axios.post(
  //       `${API_BASE}/send-sms-fast2sms`,
  //       data,
  //       {
  //         headers: {
  //           authorization: "4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     setResponse(res.data);
  //   } catch (error) {
  //     console.error("Error sending SMS:", error);
  //     setResponse({ error: error.message });
  //   }
  // };



const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedTemplateObj || !numbers) {
    alert("Template and Numbers are required");
    return;
  }

  const variables_values = variables.join("|");
  const API_BASE = "https://narrowitsolution.in/api";

  const data = {
    route: "dlt",
    sender_id: "SGDMSA",  // Your correct DLT_SENDER_ID
    message: selectedTemplateObj.message_id,
    variables_values: variables_values,
    numbers: numbers,
  };

  try {
    const res = await axios.post(
      `${API_BASE}/send-sms-fast2sms`,
      { data }, // <-- wrap inside { data: ... }
      {
        headers: {
          authorization: "4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8",
          "Content-Type": "application/json",
        },
      }
    );

    setResponse(res.data);
  } catch (error) {
    console.error("Error sending SMS:", error);
    setResponse({ error: error.message });
  }
};



  return (
    <div className="sms-form">
      <h2>Send DLT SMS</h2>
{/* 
      {loadingTemplates ? (
        <p>Loading Templates...</p>
      ) : (
        <select value={selectedTemplate} onChange={handleTemplateSelect} required>
          <option value="">Select Template</option>
          {templateList.flatMap((item) =>
            item.templates.map((tpl) => (
              <option key={tpl.message_id} value={tpl.message_id}>
                {tpl.message_id} - {tpl.message}
              </option>
            ))
          )}
        </select>
      )}

      {selectedTemplateObj && (
        <h2 style={{ margin: "15px 0", background: "#eef", padding: "10px", borderRadius: "5px" }}>
          Template Preview: {selectedTemplateObj.message} <br />
          Variables Count: {selectedTemplateObj.var_count}
        </h2>
      )}

      {variables.map((val, idx) => (
        <input
          key={idx}
          type="text"
          placeholder={`Variable ${idx + 1}`}
          value={val}
          onChange={(e) => handleVariableChange(idx, e.target.value)}
        />
      ))}

      <input
        type="text"
        placeholder="Mobile Numbers (comma separated)"
        value={numbers}
        onChange={(e) => setNumbers(e.target.value)}
        required
      />

      <button type="submit" onClick={handleSubmit}>
        Send SMS
      </button>

      {response && (
        <pre style={{ marginTop: "20px", background: "#f5f5f5", padding: "10px", borderRadius: "5px" }}>
          {JSON.stringify(response, null, 2)}
        </pre>
      )} */}
    </div>
  );
};

export default AdminMessageWithSmsForm;
